import React, { ComponentProps, ReactNode } from "react";
import { styled } from "../stitches.config";
import { stitchesCardStyles, StyledCardHeader } from "../stitches/card";

const StyledCard = styled("div", stitchesCardStyles);
type StitchesButtonProps = ComponentProps<typeof StyledCard>;
export interface CardProps extends StitchesButtonProps {
  /** Provide a text content for the card */
  children?: ReactNode;
  shadow?: boolean;
  header?: string;
}

export const Card: React.FC<CardProps> = ({ children, shadow = true, header, ...props }) => (
  <div {...props}>
    {header && <StyledCardHeader>{header}</StyledCardHeader>}
    <StyledCard shadow={shadow}>{children}</StyledCard>
  </div>
);
